import { FlowTypes } from '@interfaces/models/flow-types';
import { Store } from '@ngrx/store';
import { ContentPageId } from '@shared/models/content-page-ids';
import { type OpenchoiceRemoteContent } from '@src/aem/models/OpenchoiceRemoteContent';
import { createSafeGetFactory } from '@src/aem/utils';
import { State } from '@store/index';

export const toPageContent = (remoteContent: OpenchoiceRemoteContent, store?: Store<State>) => {
  const remoteContentItem =
    remoteContent.data.pageContainers_daMoreQuestionPageContainers.items?.[0];
  const safeGetForTaxFilingRetirement = createSafeGetFactory(
    ContentPageId.openchoice,
    FlowTypes.MINOR,
    store,
  );

  return {
    pageTitle: safeGetForTaxFilingRetirement(() => remoteContentItem?.heading, 'pageTitle'),
    pageSubtitle: safeGetForTaxFilingRetirement(
      () => remoteContentItem?.subheading,
      'pageSubtitle',
    ),
  };
};
